import { Routes, Route, Navigate } from "react-router-dom";
import { useMsal, useIsAuthenticated, useAccount } from "@azure/msal-react";
import { useEffect } from "react";
import { loginRequest } from "./auth/msal";
import { AppShell } from "./components/AppShell";
import { AccessGate } from "./components/AccessGate";
import { Landing } from "./pages/Landing";
import { HolidayNew } from "./pages/HolidayNew";
import { HolidayDetail } from "./pages/HolidayDetail";
import { PrintEstimate } from "./pages/PrintEstimate";
import { ModulePlaceholder } from "./pages/ModulePlaceholder";
import { CaseNew } from "./pages/CaseNew";
import { CaseDetail } from "./pages/CaseDetail";
import { Uplifts } from "./pages/Uplifts";
import { Awf } from "./pages/Awf";

export default function App() {
  const { instance, accounts } = useMsal();
  const isAuthed = useIsAuthenticated();
  const account = useAccount(accounts[0]);

  useEffect(() => {
    if (!isAuthed && accounts.length === 0) {
      instance.loginRedirect(loginRequest).catch(console.error);
    }
  }, [isAuthed, accounts, instance]);

  if (!isAuthed || !account) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        Signing you in to Microsoft...
      </div>
    );
  }

  return (
    <AccessGate allow={["claimant", "approver", "admin"]}>
      <Routes>
        <Route path="/estimate/:id/print" element={<PrintEstimate />} />
        <Route element={<AppShell />}>
          <Route path="/" element={<Landing />} />
          <Route path="/holiday/new" element={<HolidayNew />} />
          <Route path="/holiday/:id" element={<HolidayDetail />} />
          {/* Case-by-case */}
          <Route path="/case/new" element={<CaseNew />} />
          <Route path="/case/:id" element={<CaseDetail />} />
          {/* Annual Uplifts (tracker, no submit flow) */}
          <Route path="/uplift"     element={<Uplifts />} />
          <Route path="/uplift/new" element={<Uplifts />} />
          {/* AWF (skeleton tracker) */}
          <Route path="/awf"     element={<Awf />} />
          <Route path="/awf/new" element={<Awf />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </AccessGate>
  );
}
